import React from 'react';
import { StarFlourish } from './Decorations';
export function Footer() {
  return <footer className="py-12 px-4 border-t border-gold/20 text-center relative z-10 bg-parchment-dark" data-id="element-56">
      <div className="max-w-4xl mx-auto flex flex-col items-center" data-id="element-57">
        <div className="flex items-center gap-3 mb-6 opacity-80" data-id="element-58">
          <StarFlourish className="w-3 h-3 text-carrot" data-id="element-59" />
          <span className="font-serif text-xl tracking-wider text-velvet" data-id="element-60">
            Carrot Business Network
          </span>
          <StarFlourish className="w-3 h-3 text-carrot" delay={1} data-id="element-61" />
        </div>

        <p className="text-velvet/70 text-sm font-light mb-2" data-id="element-62">
          Hosted in support of the Lillian Prime MS Centre
        </p>
        <p className="text-velvet/55 text-xs" data-id="element-63">
          © 2026 Carrot Business Network. All illusions reserved.
        </p>
      </div>
    </footer>;
}